var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputNumberWithPopover',_vm._g(_vm._b({attrs:{"value":_vm.displayValue}},'InputNumberWithPopover',_vm.$attrs,false),Object.assign({}, _vm.$listeners,
    {input: _vm.handleInput,
    change: _vm.handleChange})))}
var staticRenderFns = []

export { render, staticRenderFns }